
<h2 style="background-color: #326395 !important;color: white;text-align:center;">
  Bank Transfer
  <button mat-button class="close-button" [mat-dialog-close]="true" style="float: right;">
    <mat-icon>close</mat-icon>
  </button>

</h2>
<p style="text-align:center;"><b style="color:red;">{{transfer_note}}</b></p>

<table class="table text-center" border="1">
  <tr>
    <td class="col">
      Transfer Amount
    </td>
    <td style="white-space: nowrap;">
      {{transfer_amount}} NGN
    </td>
  </tr>
  <tr>
    <td class="col">
      Transfer Account Number
    </td>
    <td style="white-space: nowrap;">
      {{transfer_account}}<br />
      <label style="color:red;">(Account valid for this transaction only)</label>
    </td>
  </tr>
  <tr>
    <td class="col">
      Account Expiration
    </td>

    <td style="white-space: nowrap;">
      {{account_expiration}}<br />
      <label style="color:red;">(Valid till Date and time (GMT+1))</label>
    </td>
  </tr>
  <tr>
    <td class="col">
      Transfer Bank Name
    </td>
    <td style="white-space: nowrap;">
      {{transfer_bank}}
    </td>
  </tr>
  <tr>
    <td class="col">
      Transfer Reference Number
    </td>

    <td style="white-space: nowrap;">
      {{transfer_reference}}
    </td>
  </tr>

</table>

<div style="text-align:center;">
  <button type="button" class="btn btn-danger" (click)="closeModal()">
    Close
  </button>
</div>







